import {Injectable, Inject} from '@angular/core';
import angular from "angular";
import {BaseFieldService} from "@/angular-blocworx/components/fields/BaseFieldService";
import {Configuration} from "@/angular-blocworx/components/configuration/services/configuration.service";
import {RequestService} from "@/angular-blocworx/components/configuration/services/request.service";
import {HttpClient, HttpParams} from '@angular/common/http';
import {lastValueFrom} from "rxjs";

@Injectable({
    providedIn: 'root'
})

export class CalendarResourcePlanningService extends BaseFieldService {
    constructor(
        @Inject(HttpClient) protected http: HttpClient,
        @Inject(Configuration) protected configuration: Configuration,
        @Inject(RequestService) protected request: RequestService
    ) {
        super(http, configuration, request);
    }

    getInitialParams(): object {

        return {
            'calendarResourcePlanningViewType': {
                'validation': {
                    'required': false,
                }
            },
            'calendarAreaDetailsBlocList': {
                'subParameters': {
                    'jobId': {
                        'validation': {
                            'required': false
                        }
                    }
                },
                'validation': {
                    'required': false,
                }
            },
            'sendExtraDataMatchingFields': {
                'validation': {
                    'required': false
                }
            },
            'filterDataLookUp': {
                'validation': {
                    'required': false
                }
            },
            'showLoadDataButton': {
                'validation': {
                    'required': false
                }
            },
            'calendarAreaBlocDetails': {
                'subParameters': {
                    'stationId': {
                        'validation': {
                            'required': true,
                            'validationResponse': 'Please choose a Bloc to look up',
                            'requiredType': 'stringMustNotBeEmpty'
                        }
                    },
                    'startingDateTimeFieldId': {
                        'validation': {
                            'required': false
                        }
                    },
                    'endingDateTimeFieldId': {
                        'validation': {
                            'required': false
                        }
                    },
                    'calendarItemLabelField': {
                        'validation': {
                            'required': false
                        }
                    },
                    'calendarUpdatableField': {
                        'validation': {
                            'required': false
                        }
                    },
                    'calendarLeftSideMatchingField': {
                        'validation': {
                            'required': false
                        }
                    },
                    'calendarRecordColourField': {
                        'validation': {
                            'required': false
                        }
                    }
                },
                'validation': {
                    'required': true,
                    'validationResponse': 'Please select a bloc and a field to look up',
                    'requiredType': 'listMustHaveOne'
                }
            },
            'localFieldMatchingFieldPairs': {
                'validation': {
                    'required': false,
                }
            },
            'dropdownFromStationReverseOrder': {
                'validation': {
                    'required': false,
                }
            },
            'localDataListFieldId': {
                'validation': {
                    'required': false,
                }
            },
            'calendarResourcePlanningApplyBlocInitialisation': {
                'validation': {
                    'required': false,
                }
            },
            'calendarResourcePlanningApplyFieldActions': {
                'validation': {
                    'required': false,
                }
            },
            'calendarResourcePlanningPreSubmitFeatures': {
                'validation': {
                    'required': false,
                }
            },
            'enableZoomPinchOnMobileTablet': {
                'validation': {
                    'required': false,
                }
            },
            'showCountsOfRecordsInsteadOfIndividual': {
                'validation': {
                    'required': false,
                }
            },
            'makeCalendarResponsive': {
                'validation': {
                    'required': false,
                }
            },
            'automaticallyMakeFullScreenOnLoad': {
                'validation': {
                    'required': false,
                }
            },
            'chooseColourForCountData': {
                'validation': {
                    'required': false,
                }
            },
            'showSingleDayWithHoursViewOnDateClick': {
                'validation': {
                    'required': false,
                }
            }
        };
    }

    // TODO Can be generic to editing fields
    addOrRemoveLocalAndRemoteMatchingFieldPairs (localFieldMatchingFieldPairs, action, localField, remoteField, index = null) {

        if((localField == '' || typeof localField == 'undefined') && action == 'add') {
            alert('Please Select a local Field');
            return localFieldMatchingFieldPairs;
        }

        if((remoteField == '' || typeof remoteField == 'undefined') && action == 'add') {
            alert('Please Select a remote field it must match');
            return localFieldMatchingFieldPairs;
        }

        if( localFieldMatchingFieldPairs == null || localFieldMatchingFieldPairs == "") {
            localFieldMatchingFieldPairs = {};
        }

        if(action == 'add') {
            localFieldMatchingFieldPairs[Object.keys(localFieldMatchingFieldPairs).length] = {
                'localFieldId' : localField,
                'remoteFieldId' : remoteField
            };

        } else {
            delete localFieldMatchingFieldPairs[index];
            // build new object with fresh keys to keep it in sync
            let fieldListForLoop = localFieldMatchingFieldPairs;
            localFieldMatchingFieldPairs = {};
            let i: number = 0;
            angular.forEach(fieldListForLoop, function(value) {
                localFieldMatchingFieldPairs[i] = value;
                i++;
            });
        }

        return localFieldMatchingFieldPairs;

    }

    getDataForCalendarField = async (fieldId, dateForCalendarData, dataFilteringData, calendarResourcePlanningViewType:any = false) : Promise<any> =>{

        let apiBase:string = this.evervaultEnabledApiUrl + 'get-data-for-calendar-field';

        let params = new HttpParams().set('fieldId', fieldId).set('dateForCalendarData',dateForCalendarData);

        if(calendarResourcePlanningViewType != false) {
            params = params.set('calendarResourcePlanningViewType',calendarResourcePlanningViewType);
        }

        if(dataFilteringData.stationID != "") {
            params = params.set('dataFilteringData',JSON.stringify(dataFilteringData))
        }

        let headers = this.request.getHeaders();

        const response = this.http.get(apiBase, {params, headers});

        return lastValueFrom(response);
    }

    public changeEndDateValueFromCalendar = (fieldId, cartolyticsEntryRowId, newDate, calendarResourcePlanningViewType: any = false): Promise<any> => {
        const headers = this.request.getHeaders()

        const body = {
            fieldId,
            cartolyticsEntryRowId,
            newDate,
            calendarResourcePlanningViewType
        }
        const response = this.http.post(`${this.apiUrl}change-end-date-value-from-calendar`, body, {headers});
        return lastValueFrom(response)
    }

    public moveRecordWithinCalendar = (fieldId, cartolyticsEntryRowId, startDate, numberOfDays, leftValue, calendarResourcePlanningViewType: any = false): Promise<any> => {
        const headers = this.request.getHeaders()

        const body = {
            fieldId,
            cartolyticsEntryRowId,
            startDate,
            numberOfDays,
            leftValue,
            calendarResourcePlanningViewType
        }
        const response = this.http.post(`${this.apiUrl}move-record-within-calendar`, body, {headers});
        return lastValueFrom(response)
    }

    public addNewOrUpdateRecordFromCalendar = (fieldId, startDate, labelValue, leftValue, extraDataToSend, endDate = null, cartolyticsEntryRowId = null, calendarResourcePlanningViewType:any = false): Promise<any> => {
        const headers = this.request.getHeaders()

        const body = {
            fieldId,
            startDate,
            labelValue,
            leftValue,
            extraDataToSend,
            endDate,
            cartolyticsEntryRowId,
            calendarResourcePlanningViewType
        }

        const response = this.http.post(`${this.evervaultEnabledApiUrl}add-new-or-update-record-from-calendar`, body, {headers});
        return lastValueFrom(response)
    }

    public updateRecordValueFromCalendar = (fieldId, cartolyticsEntryRowId, calendarUpdatableFieldValue, calendarResourcePlanningViewType: any = false): Promise<any> => {
        const headers = this.request.getHeaders()

        const body = {
            fieldId,
            cartolyticsEntryRowId,
            calendarUpdatableFieldValue,
            calendarResourcePlanningViewType
        }
        const response = this.http.post(`${this.evervaultEnabledApiUrl}update-record-value-from-calendar`, body, {headers});
        return lastValueFrom(response)
    }

    deleteRecord = async (entryID) : Promise<any> =>{

        let apiBase:string = this.apiUrl + 'delete-data';

        let params = new HttpParams().set('entryID',entryID);

        let headers = this.request.getHeaders();

        const response = this.http.delete(apiBase, {params, headers});

        return lastValueFrom(response);
    }


}

